import { SxProps, Theme } from "@mui/material";

export const modalStyles: SxProps<Theme> = {
  zIndex: 10000,
  position: "fixed",
};

export const backdropStyles: SxProps<Theme> = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  backdropFilter: "blur(4px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 10000,
};

export const getModalContentStyles = (isDark: boolean): SxProps<Theme> => ({
  background: "#1F2130",
  borderRadius: "12px",
  padding: "16px",
  maxWidth: "400px",
  width: "90%",
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  boxShadow: "rgba(200, 169, 169, 0.35) 0px 5px 15px",
  border: "1px solid rgba(255, 255, 255, 0.15)",
});

export const warningHeaderStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "flex-start",
  gap: 1.5,
  mb: 0.5,
};

export const warningIconStyles: SxProps<Theme> = {
  color: "#F59E0B",
  fontSize: "20px",
  flexShrink: 0,
  mt: 0.25,
};

export const warningTextStyles: SxProps<Theme> = {
  flex: 1,
  lineHeight: 1.5,
  fontFamily: "Red Hat Display",
};

export const buttonsContainerStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 1,
};

export const getButtonBaseStyles = (isDark: boolean): SxProps<Theme> => ({
  backgroundColor: "transparent",
  background: "#0E0E0E99",
  color: "#FFFFFF",
  border: "none",
  boxShadow:
    "inset 0 0 0 1px rgba(255, 255, 255, 0.3), 0 1px 2px rgba(0, 0, 0, 0.2), 0 -1px 1px rgba(255, 255, 255, 0.08), rgba(200, 169, 169, 0.2) 0px 2px 8px",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.25)",
    background: "#0E0E0E99",
    boxShadow:
      "inset 0 0 0 1px rgba(255, 255, 255, 0.5), 0 2px 3px rgba(0, 0, 0, 0.25), 0 -1px 2px rgba(255, 255, 255, 0.1), rgba(200, 169, 169, 0.25) 0px 3px 10px",
  },
  "&:active": {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    background: "#0E0E0E99",
    boxShadow:
      "inset 0 1px 2px rgba(0, 0, 0, 0.2), inset 0 -1px 1px rgba(255, 255, 255, 0.08), 0 1px 1px rgba(0, 0, 0, 0.15), rgba(200, 169, 169, 0.2) 0px 2px 8px",
  },
  textTransform: "none",
  padding: "10px 16px",
  borderRadius: "12px",
  marginBottom: "4px",
  fontSize: "0.875rem",
  fontWeight: 500,
  fontFamily: "Red Hat Display",
  transition: "background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
});
